export const GlobalSettingsId = 'd286fb64-e3d2-427e-b335-68bafc3b498c';
